import React from 'react';

export interface AddIconProps {
	color?: string;
	className?: string;
	onClick?: () => void;
	height?: number;
	width?: number;
}

export class AddIcon extends React.PureComponent<AddIconProps> {
	get color() {
		return this.props.color ? this.props.color : '#0088CC';
	}

	public override render() {
		const height = this.props.height || 21;
		const width = this.props.width || 21;
		return <svg className={this.props.className} width={width} height={height} viewBox={`0 0 21 21`}
		            onClick={this.props.onClick}>
			<path xmlns='http://www.w3.org/2000/svg'
			      d='M11.6094 5.44434H9.60938V9.44434H5.60938V11.4443H9.60938V15.4443H11.6094V11.4443H15.6094V9.44434H11.6094V5.44434ZM10.6094 0.444336C5.08938 0.444336 0.609375 4.92434 0.609375 10.4443C0.609375 15.9643 5.08938 20.4443 10.6094 20.4443C16.1294 20.4443 20.6094 15.9643 20.6094 10.4443C20.6094 4.92434 16.1294 0.444336 10.6094 0.444336ZM10.6094 18.4443C6.19938 18.4443 2.60938 14.8543 2.60938 10.4443C2.60938 6.03434 6.19938 2.44434 10.6094 2.44434C15.0194 2.44434 18.6094 6.03434 18.6094 10.4443C18.6094 14.8543 15.0194 18.4443 10.6094 18.4443Z'
			      fill={this.color}/>
		</svg>;
	}
}
